var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "add-content" },
    [
      _vm._m(0),
      _c("div", { staticClass: "form-dis" }, [
        _c("div", { staticClass: "item-width form-left" }, [
          _c(
            "div",
            { staticClass: "form-item" },
            [
              _c("div", { staticClass: "item-name name-left" }, [
                _vm._v("故事名称"),
              ]),
              _c("el-input", {
                attrs: { placeholder: "请输入故事名称" },
                model: {
                  value: _vm.story.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.story, "name", $$v)
                  },
                  expression: "story.name",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "form-item" },
            [
              _c("div", { staticClass: "item-name name-left" }, [
                _vm._v("故事分类"),
              ]),
              _c(
                "el-select",
                {
                  attrs: {
                    filterable: "",
                    placeholder: "请选择故事分类",
                    "value-key": "code",
                  },
                  on: { change: _vm.changeType },
                  model: {
                    value: _vm.story.storyType,
                    callback: function ($$v) {
                      _vm.$set(_vm.story, "storyType", $$v)
                    },
                    expression: "story.storyType",
                  },
                },
                _vm._l(_vm.typeList, function (type) {
                  return _c("el-option", {
                    key: type.code,
                    attrs: { label: type.value, value: type },
                  })
                }),
                1
              ),
            ],
            1
          ),
        ]),
        _c(
          "div",
          { staticClass: "des item-width" },
          [
            _c("div", { staticClass: "item-name" }, [_vm._v("故事描述")]),
            _c("el-input", {
              attrs: {
                rows: "3",
                type: "textarea",
                placeholder: "请输入故事描述",
              },
              model: {
                value: _vm.story.description,
                callback: function ($$v) {
                  _vm.$set(_vm.story, "description", $$v)
                },
                expression: "story.description",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._m(1),
      _c(
        "div",
        { staticClass: "scene-list" },
        [
          _c(
            "div",
            { staticClass: "add-scene" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.addTab(_vm.editableTabsValue)
                    },
                  },
                },
                [_vm._v(" +添加故事场景 ")]
              ),
            ],
            1
          ),
          _c(
            "el-tabs",
            {
              attrs: { type: "card", closable: "" },
              on: { "tab-remove": _vm.removeTab, "tab-click": _vm.clickTab },
              model: {
                value: _vm.editableTabsValue,
                callback: function ($$v) {
                  _vm.editableTabsValue = $$v
                },
                expression: "editableTabsValue",
              },
            },
            _vm._l(_vm.sceneList, function (sceneItem, index) {
              return _c(
                "el-tab-pane",
                {
                  key: sceneItem.name,
                  attrs: { label: sceneItem.title, name: sceneItem.name },
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        height: "100%",
                        display: "flex",
                        "flex-direction": "column",
                        overflow: "auto",
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "scene-item" },
                        [
                          _c("div", { staticClass: "item-name name-left" }, [
                            _vm._v("场景名称"),
                          ]),
                          _c("el-input", {
                            attrs: { placeholder: "请输入场景名称" },
                            model: {
                              value: _vm.sceneList[index].sceneName,
                              callback: function ($$v) {
                                _vm.$set(_vm.sceneList[index], "sceneName", $$v)
                              },
                              expression: "sceneList[index].sceneName",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "scene-des" },
                        [
                          _c("div", { staticClass: "item-name" }, [
                            _vm._v("场景描述"),
                          ]),
                          _c("el-input", {
                            attrs: {
                              rows: "3",
                              type: "textarea",
                              placeholder: "请输入场景描述",
                            },
                            model: {
                              value: _vm.sceneList[index].description,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.sceneList[index],
                                  "description",
                                  $$v
                                )
                              },
                              expression: "sceneList[index].description",
                            },
                          }),
                        ],
                        1
                      ),
                      _c("div", { staticClass: "task-title" }, [
                        _c("div", [_vm._v("步骤合集")]),
                        _c("div", [
                          _c("span", { on: { click: _vm.showModeDialog } }, [
                            _vm._v("+添加模版步骤"),
                          ]),
                          _c("span", { on: { click: _vm.showCustomDialog } }, [
                            _vm._v("+添加自定义步骤"),
                          ]),
                        ]),
                      ]),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            flex: "1",
                            display: "flex",
                            "flex-direction": "column",
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "select-list" },
                            _vm._l(
                              sceneItem.taskElements,
                              function (item, task_index) {
                                return _c(
                                  "div",
                                  {
                                    key: task_index,
                                    staticClass: "list-item",
                                    style: {
                                      background:
                                        _vm.selectTaskIndex === task_index
                                          ? "#ecf5ff"
                                          : "",
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.editTask(
                                              item,
                                              task_index
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(item.name))]
                                    ),
                                    _c("i", {
                                      staticClass: "el-icon-close close-icon",
                                      on: {
                                        click: function ($event) {
                                          return _vm.delTask(
                                            index,
                                            task_index,
                                            item
                                          )
                                        },
                                      },
                                    }),
                                  ]
                                )
                              }
                            ),
                            0
                          ),
                          _vm.showTaskContent
                            ? _c(
                                "div",
                                { staticClass: "tast-detail task-margin" },
                                [
                                  _c(
                                    "el-form",
                                    {
                                      ref: "ruleForm",
                                      refInFor: true,
                                      attrs: {
                                        model: _vm.taskContent,
                                        "label-width": "100px",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "问题",
                                            prop: "question",
                                          },
                                        },
                                        [
                                          _c("el-input", {
                                            attrs: { type: "textarea" },
                                            model: {
                                              value:
                                                _vm.taskContent.questions[0],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.taskContent.questions,
                                                  0,
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "taskContent.questions[0]",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "答案",
                                            prop: "answer",
                                          },
                                        },
                                        [
                                          _c("el-input", {
                                            attrs: { type: "textarea" },
                                            model: {
                                              value: _vm.taskContent.answer,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.taskContent,
                                                  "answer",
                                                  $$v
                                                )
                                              },
                                              expression: "taskContent.answer",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "问题意图",
                                            prop: "questionIntent",
                                          },
                                        },
                                        [
                                          _c("el-input", {
                                            attrs: { type: "textarea" },
                                            model: {
                                              value:
                                                _vm.taskContent.questionIntent,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.taskContent,
                                                  "questionIntent",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "taskContent.questionIntent",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "答案意图",
                                            prop: "answerIntent",
                                          },
                                        },
                                        [
                                          _c("el-input", {
                                            attrs: { type: "textarea" },
                                            model: {
                                              value:
                                                _vm.taskContent.answerIntent,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.taskContent,
                                                  "answerIntent",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "taskContent.answerIntent",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "check-list check-detail" },
                                    [
                                      _c("div", [_vm._v(" 检查点： ")]),
                                      _vm._l(
                                        _vm.taskContent.checkList,
                                        function (item, index) {
                                          return _c(
                                            "div",
                                            { key: index },
                                            [
                                              _c("el-input", {
                                                model: {
                                                  value:
                                                    _vm.taskContent.checkList[
                                                      index
                                                    ],
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.taskContent.checkList,
                                                      index,
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "taskContent.checkList[index]",
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                    ],
                                    2
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      ),
                    ]
                  ),
                ]
              )
            }),
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "sava-btn" },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.saveData } },
            [_vm._v("保存")]
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.modeTableVisible,
            width: "70%",
            top: "10vh",
            "show-close": false,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.modeTableVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "mode-dialog" }, [
            _c(
              "div",
              { staticClass: "form-item" },
              [
                _c("div", { staticClass: "item-name" }, [_vm._v("选择模版")]),
                _c(
                  "el-select",
                  {
                    staticStyle: { "margin-left": "-6px" },
                    attrs: {
                      disabled: _vm.isSelectTask,
                      placeholder: "请选择任务模版",
                      "value-key": "id",
                    },
                    on: { change: _vm.changeTaskBase },
                    model: {
                      value: _vm.currentTaskBase,
                      callback: function ($$v) {
                        _vm.currentTaskBase = $$v
                      },
                      expression: "currentTaskBase",
                    },
                  },
                  _vm._l(_vm.taskBaseList, function (task) {
                    return _c("el-option", {
                      key: task.id,
                      attrs: { label: task.name, value: task },
                    })
                  }),
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "form-item task-select" },
              [
                _c("div", { staticClass: "item-name" }, [_vm._v("全选")]),
                _c("el-switch", {
                  attrs: { "active-color": "#419eee" },
                  on: { change: _vm.selectTask },
                  model: {
                    value: _vm.allTask,
                    callback: function ($$v) {
                      _vm.allTask = $$v
                    },
                    expression: "allTask",
                  },
                }),
              ],
              1
            ),
            _c("div", { staticClass: "dialog-content" }, [
              _c(
                "div",
                { staticClass: "mode-content" },
                [
                  _c(
                    "el-collapse",
                    _vm._l(_vm.taskList, function (currentTask, index) {
                      return _c(
                        "el-collapse-item",
                        { key: currentTask.id },
                        [
                          _c(
                            "template",
                            { slot: "title" },
                            [
                              _c(
                                "el-checkbox",
                                {
                                  on: {
                                    change: function ($event) {
                                      return _vm.selectQuestion(index)
                                    },
                                  },
                                  model: {
                                    value: currentTask.checked,
                                    callback: function ($$v) {
                                      _vm.$set(currentTask, "checked", $$v)
                                    },
                                    expression: "currentTask.checked",
                                  },
                                },
                                [_vm._v(_vm._s(currentTask.name))]
                              ),
                            ],
                            1
                          ),
                          _c("div", { staticClass: "tast-detail" }, [
                            _c("div", { staticClass: "question-content" }, [
                              _c("div", { staticClass: "content-item text" }, [
                                _c("div", [
                                  _vm._v(
                                    "问题： " + _vm._s(currentTask.questions[0])
                                  ),
                                ]),
                                _c("div", [
                                  _vm._v(
                                    "答案： " + _vm._s(currentTask.answer)
                                  ),
                                ]),
                              ]),
                              _c("div", { staticClass: "content-item" }, [
                                _c("div", [
                                  _vm._v(
                                    "问题意图： " +
                                      _vm._s(currentTask.questionIntent)
                                  ),
                                ]),
                                _c("div", [
                                  _vm._v(
                                    "答案意图： " +
                                      _vm._s(currentTask.answerIntent)
                                  ),
                                ]),
                              ]),
                            ]),
                            _c(
                              "div",
                              { staticClass: "check-list" },
                              [
                                _c("div", [_vm._v(" 检查点： ")]),
                                _vm._l(
                                  currentTask.checkList,
                                  function (item, index) {
                                    return _c("div", { key: index }, [
                                      _c("span", [_vm._v(_vm._s(item))]),
                                    ])
                                  }
                                ),
                              ],
                              2
                            ),
                          ]),
                        ],
                        2
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
            ]),
            _c(
              "div",
              { staticClass: "mode-btn" },
              [
                _c(
                  "el-button",
                  {
                    staticClass: "sub-btn",
                    on: {
                      click: function ($event) {
                        return _vm.closeMode()
                      },
                    },
                  },
                  [_vm._v("取消")]
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "sub-btn",
                    attrs: { type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.saveTask()
                      },
                    },
                  },
                  [_vm._v("确定")]
                ),
              ],
              1
            ),
          ]),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.customTableVisible,
            width: "75%",
            "show-close": false,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.customTableVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "custom-dialog" },
            [
              _c(
                "el-form",
                {
                  ref: "ruleForm",
                  attrs: {
                    model: _vm.taskForm,
                    rules: _vm.rules,
                    "label-width": "100px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "问题", prop: "question" } },
                    [
                      _c("el-input", {
                        attrs: { type: "textarea" },
                        model: {
                          value: _vm.taskForm.question,
                          callback: function ($$v) {
                            _vm.$set(_vm.taskForm, "question", $$v)
                          },
                          expression: "taskForm.question",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "答案", prop: "answer" } },
                    [
                      _c("el-input", {
                        attrs: { type: "textarea" },
                        model: {
                          value: _vm.taskForm.answer,
                          callback: function ($$v) {
                            _vm.$set(_vm.taskForm, "answer", $$v)
                          },
                          expression: "taskForm.answer",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "问题意图", prop: "questionIntent" } },
                    [
                      _c("el-input", {
                        attrs: { type: "textarea" },
                        model: {
                          value: _vm.taskForm.questionIntent,
                          callback: function ($$v) {
                            _vm.$set(_vm.taskForm, "questionIntent", $$v)
                          },
                          expression: "taskForm.questionIntent",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "答案意图", prop: "answerIntent" } },
                    [
                      _c("el-input", {
                        attrs: { type: "textarea" },
                        model: {
                          value: _vm.taskForm.answerIntent,
                          callback: function ($$v) {
                            _vm.$set(_vm.taskForm, "answerIntent", $$v)
                          },
                          expression: "taskForm.answerIntent",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("div", { staticClass: "task-check" }, [
                _c("div", { staticClass: "check-name" }, [_vm._v("检查点")]),
                _c(
                  "div",
                  { staticClass: "custom-check" },
                  _vm._l(_vm.taskForm.checkList, function (check, c_i) {
                    return _c(
                      "div",
                      { key: c_i, staticClass: "check" },
                      [
                        _c("el-input", {
                          attrs: { type: "textarea", rows: 2 },
                          model: {
                            value: _vm.taskForm.checkList[c_i],
                            callback: function ($$v) {
                              _vm.$set(_vm.taskForm.checkList, c_i, $$v)
                            },
                            expression: "taskForm.checkList[c_i]",
                          },
                        }),
                        _c("i", {
                          staticClass: "el-icon-circle-plus-outline",
                          on: { click: _vm.addCheck },
                        }),
                        _vm.taskForm.checkList.length > 1
                          ? _c("i", {
                              staticClass: "el-icon-remove-outline",
                              on: {
                                click: function ($event) {
                                  return _vm.taskForm.checkList.splice(c_i, 1)
                                },
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    )
                  }),
                  0
                ),
              ]),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "custom-btn" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.closeCustom()
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.saveCustom()
                    },
                  },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "top-title" }, [
      _c("div"),
      _c("div", [_vm._v("故事基本信息")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "top-title middle-top" }, [
      _c("div"),
      _c("div", [_vm._v("故事内容")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }